import { render, staticRenderFns } from "./ImportGrid.vue?vue&type=template&id=7a1d2b4e&scoped=true&"
import script from "./ImportGrid.vue?vue&type=script&lang=ts&"
export * from "./ImportGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ImportGrid.vue?vue&type=style&index=0&id=7a1d2b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1d2b4e",
  null
  
)

export default component.exports